import React, { Component } from "react";
import "../App.css";
import loginbanner from "../assets/loginbanner.jpg";
import burcellogo from "../assets/burcelLogo.png";

import MobilePage from "./MobilePage";
import SetPassword from "./SetPassword";
import Validation from "./ValidationCode";
import Password from "./Password";
import { Route, Redirect } from "react-router-dom";
import Loading from "../components/Loading";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: "nothing",
      serverResponse: false,
      mobile: "",
      width: 0,
    };

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth });
    // document.title=window.innerWidth.toString();
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    // document.body.style.backgroundColor = 'var(--white2)';
    document.body.style.backgroundColor = "white";
    if (
      localStorage.getItem("mobile") !== null &&
      localStorage.getItem("mobile") !== undefined &&
      localStorage.getItem("mobile") !== "" &&
      localStorage.getItem("token") !== null &&
      localStorage.getItem("token") !== undefined &&
      localStorage.getItem("token") !== ""
    ) {
      let data = {
        mobile: localStorage.getItem("mobile"),
        token: localStorage.getItem("token"),
      };

      fetch("/api/checkToken", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((resultt) => {
          if (resultt.status === 200) {
            this.props.history.push("/");
          } else {
            this.setState({ serverResponse: true });
          }
        })
        .catch((err) => {
          this.setState({ serverResponse: false });
        });
    } else {
      this.setState({ serverResponse: true });
    }
  }

  onCorrectPassword() {
    this.props.history.push("/Steps/Brokers");
  }

  onSetPassword() {
    this.props.history.push("/Steps/Brokers");
  }

  onForgetPassword() {
    this.props.history.push(this.props.match.path + "/ValidationCode");
  }

  onValidatedCode() {
    this.props.history.push(this.props.match.path + "/SetPassword");
  }

  onValidatedCodeBack() {
    this.props.history.goBack();
  }

  // onGetMobile(mobileValue){
  //   this.setState({mobile:mobileValue});
  //   this.props.history.push(this.props.match.path+"/Password");
  // }

  render() {
    if (this.state.serverResponse) {
      if (localStorage.getItem("token") === this.state.token) {
        return <Redirect to="/" />;
      } else {
        if (this.state.width < 768) {
          return (
            <div className="wrapper">
              <div className="loginForm">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    flex: "1",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "flex-end",
                      width: "100%",
                      position: "absolute",
                      paddingTop: "20px",
                    }}
                  >
                    <div
                      style={{
                        flex: "1",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <img
                        src={burcellogo}
                        style={{ width: "70%", maxWidth: "400px" }}
                        alt="burcel"
                      />
                    </div>
                  </div>
                  <div className="form-wrapper">
                    <Route
                      exact
                      path={this.props.match.path}
                      component={MobilePage}
                    />
                    <Route
                      path={`${this.props.match.path}/Password`}
                      render={(props) => (
                        <Password
                          {...props}
                          onCorrectPassword={this.onCorrectPassword.bind(this)}
                          onForgetPassword={this.onForgetPassword.bind(this)}
                          onPasswordBack={this.onValidatedCodeBack.bind(this)}
                        />
                      )}
                    />
                    <Route
                      path={`${this.props.match.path}/SetPassword`}
                      render={(props) => (
                        <SetPassword
                          {...props}
                          onSetPassword={this.onSetPassword.bind(this)}
                        />
                      )}
                    />
                    <Route
                      path={`${this.props.match.path}/ValidationCode`}
                      render={(props) => (
                        <Validation
                          {...props}
                          onValidatedCode={this.onValidatedCode.bind(this)}
                          onValidatedCodeBack={this.onValidatedCodeBack.bind(
                            this
                          )}
                        />
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        } else {
          return (
            <div className="wrapper">
              <div className="loginForm">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    flex: "1",
                  }}
                >
                  {/* {this.state.width<768 && <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'flex-end',width:'100%',position:'absolute',paddingTop:'20px'}}>
                  <div style={{flex:'1',display:'flex',justifyContent:'center',alignItems:'center',width:'100%'}} ><img src={burcellogo} style={{width:'70%',maxWidth:'400px',}} alt="burcel"/></div>
                </div>} */}
                  <div className="form-wrapper">
                    <Route
                      exact
                      path={this.props.match.path}
                      component={MobilePage}
                    />
                    <Route
                      path={`${this.props.match.path}/Password`}
                      render={(props) => (
                        <Password
                          {...props}
                          onCorrectPassword={this.onCorrectPassword.bind(this)}
                          onForgetPassword={this.onForgetPassword.bind(this)}
                          onPasswordBack={this.onValidatedCodeBack.bind(this)}
                        />
                      )}
                    />
                    <Route
                      path={`${this.props.match.path}/SetPassword`}
                      render={(props) => (
                        <SetPassword
                          {...props}
                          onSetPassword={this.onSetPassword.bind(this)}
                        />
                      )}
                    />
                    <Route
                      path={`${this.props.match.path}/ValidationCode`}
                      render={(props) => (
                        <Validation
                          {...props}
                          onValidatedCode={this.onValidatedCode.bind(this)}
                          onValidatedCodeBack={this.onValidatedCodeBack.bind(
                            this
                          )}
                        />
                      )}
                    />
                  </div>
                </div>

                <div style={{ flex: "1" }}>
                  <img
                    src={loginbanner}
                    style={{
                      width: "100%",
                      minHeight: "100%",
                      maxHeight: "100%",
                      objectFit: "cover",
                    }}
                    alt="burcel"
                  />
                </div>
              </div>
            </div>
          );
        }
      }
    } else {
      return <Loading />;
    }
  }
}

export default Login;
